import "./OcipError.css";
import React from "react";

const Basic_Error = ({ SelInverter }) => {
  // 빈 사각형 2개
  const items = [
    { label: "-", num: 1 },
    { label: "-", num: 2 },
  ];

  return (
    <div className="status-list-container">
      <div className="status-list">
        {items.map(({ label, num }) => {
          return (
            <div key={num} className="status-item">
              <span className="status-value">
                {label}
              </span>
              <button>
                <span>
                  🟢
                </span>
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Basic_Error;
